"use client";

import { useTranslation } from "@/lib/hooks/use-translation";

import {
  BlogPost,
  getLocalizedBlogPost,
  rewriteArticleHtml,
} from "../data/blog-posts";

type BlogDetailContentProps = {
  post: BlogPost;
};

export function BlogDetailContent({ post }: BlogDetailContentProps) {
  const { language } = useTranslation();
  const localizedPost = getLocalizedBlogPost(post, language);

  // Body is rich-text HTML authored in the CMS; `.blog-article` styles it. It
  // is corrected on the way out rather than in the database — old v1 links,
  // stray <h1>s and file-name alt text; see `rewriteArticleHtml`.
  const html = rewriteArticleHtml(
    localizedPost.content,
    language,
    localizedPost.title,
  );

  return (
    <div
      className="blog-article mx-auto w-full max-w-none text-black"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
